import React from "react";
import { useReveal } from "../hooks/useScroll";

/* The eight trade channels the platform is actually built around. This is the
   section that answers "so it is a bar thing", which it has not been for a
   while. Every example here is a place SipNScore already models: the location
   types and team roles come straight out of the portal's taxonomy. */
const CHANNELS = [
  {
    n: "01",
    t: "On-trade",
    p: "Where it is poured, served or handed over. A code on the tray, the tasting card or the person carrying it.",
    tags: ["Bars", "Restaurants", "Taverns", "Hotels", "Coffee shops"],
  },
  {
    n: "02",
    t: "Off-trade",
    p: "Where it is picked off a shelf. The scan happens between the aisle and the till, which is the only moment the reason is still fresh.",
    tags: ["Supermarkets", "Bottle stores", "Forecourts", "Convenience"],
  },
  {
    n: "03",
    t: "Online and D2C",
    p: "A code in the box, on the slip or in the listing. The order told you what they bought. This tells you why, and who.",
    tags: ["Own store", "Marketplaces", "Delivery apps", "Subscription"],
  },
  {
    n: "04",
    t: "B2B",
    p: "The wholesaler, the trade day, the rep's call sheet. Attribution down to the person who actually made the case move.",
    tags: ["Wholesale", "Cash & carry", "Trade shows", "Field sales"],
  },
  {
    n: "05",
    t: "B2B2C",
    p: "Your product inside somebody else's business. The office machine, the hotel minibar, the partner's loyalty app.",
    tags: ["Workplace", "Hospitality", "Partner apps", "Co-branded"],
  },
  {
    n: "06",
    t: "Experiential",
    p: "Festivals, pop-ups, roadshows, sampling. Thousands of people who tasted it once, and until now left nothing behind.",
    tags: ["Festivals", "Pop-ups", "Roadshows", "Sampling", "Stadiums"],
  },
  {
    n: "07",
    t: "Travel retail",
    p: "Duty free, airport bars, in-flight. High intent, high margin, and traditionally the least measured shelf you own.",
    tags: ["Duty free", "Airport", "In-flight", "Cruise"],
  },
  {
    n: "08",
    t: "Corporate",
    p: "Staff, incentives, internal launches and supplier programmes. The same engine, pointed inward.",
    tags: ["Staff", "Incentives", "Launches", "Supplier"],
  },
];

export default function Channels() {
  const ref = useReveal();
  return (
    <section className="sec sec--pad" id="channels" ref={ref}>
      <div className="shell">
        <div className="rv">
          <span className="eyebrow">Where it works</span>
          <h2 className="h-lg" style={{ marginTop: 20, maxWidth: "17ch" }}>
            It started at the bar. It did not stay there.
          </h2>
          <p className="lede" style={{ marginTop: 22 }}>
            Coffee in an office. A capsule off a shelf. A case sold to a
            wholesaler. A sample at a festival. Anywhere a person and a product
            meet, there is a moment worth knowing about, and almost all of them
            currently pass without a trace.
          </p>
        </div>

        <div className="chan" style={{ marginTop: 48 }}>
          {CHANNELS.map((c, i) => (
            <article className="chan__c rv" key={c.n} style={{ "--d": `${i * 45}ms` }}>
              <span className="chan__n">{c.n}</span>
              <h4>{c.t}</h4>
              <p>{c.p}</p>
              <ul>
                {c.tags.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <p className="rv body" style={{ marginTop: 32, maxWidth: "62ch", color: "var(--fg-3)" }}>
          Sixty-plus location types and seventeen team roles ship with the
          platform, so a promoter at a festival, a merchandiser in an aisle and
          a listing on a delivery app are all first-class, not a text field
          somebody typed a guess into.
        </p>
      </div>
    </section>
  );
}
